module.exports = __webpack_public_path__ + "img/Phone_08.227ba9e2.jpg";